import { MESSAGE } from '../../constants/constasts';
import './style.scss';

function ChronometerComponent(props: any) {
    let progress:any = {
        background: 'none'
    }

    if(props.progress > 0){        
        progress = {
            background: `conic-gradient(
                rgba(0, 0, 0, 0.2) ${props.progress * 3.6}deg,
                rgba(0, 0, 0, 0.01) ${props.progress * 3.6}deg
            )`
        }
    }   

    let timeAnimation: any = {
        transform: 'rotate(-90deg) translateX(200px)'
    }

    if (props.message === MESSAGE.box) {
        timeAnimation = {
            animation: `run ${props.timeAnimation}s linear infinite`,
            animationPlayState: 'running'
        }

    } else if (props.message === MESSAGE.pause) {        
        timeAnimation = {
            animation: `run ${props.timeAnimation}s linear infinite`,
            animationPlayState: 'paused'
        }
    }

    

    return (
        <div className='main'>
            <div className='chronometer' style={progress}>
                <div>
                    <div className='f-rounds'>Rounds: {props.round} de {props.rounds}</div>
                    <div className='f-chronometer'>
                        <span>{(props.m >= 10) ? props.m : "0" + props.m}</span>&nbsp;:&nbsp;
                        <span>{(props.s >= 10) ? props.s : "0" + props.s}</span>
                    </div>
                    <div className='f-message'>{props.message}</div>
                </div>
            </div>
            <div style={timeAnimation} className='sphere'></div>

        </div>

    );
}

export default ChronometerComponent;